import { makeStyles } from '@material-ui/core/styles';

export const useSharedToolStyles = makeStyles({
  icon: {
    color: 'var(--text-subdued)',
    flexShrink: 0,
  },
});
